import { render, staticRenderFns } from "./PosReading.vue?vue&type=template&id=5d25d1d2&scoped=true"
import script from "./PosReading.vue?vue&type=script&lang=js"
export * from "./PosReading.vue?vue&type=script&lang=js"
import style0 from "./PosReading.vue?vue&type=style&index=0&id=5d25d1d2&prod&lang=scss&scoped=true"
import style1 from "./PosReading.vue?vue&type=style&index=1&id=5d25d1d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25d1d2",
  null
  
)

export default component.exports